<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size sm_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.EUROPE.FUNC') }}</i>
                    </dt>
                    <dd>
                        <div class="Select_wrap">
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <a href="javascript:" class="btn_white w100" @click="addEu()">
                                        {{ $t('BUTTON.GLOBAL.ADDEU') }}
                                    </a>
                                </div>
                                <div>
                                    <a href="javascript:" class="btn_white w100" @click="deleteAll()">
                                        {{ $t('BUTTON.GLOBAL.DELETEALL') }}
                                    </a>
                                </div>
                                <div>
                                    <a href="javascript:" class="btn_white w100" @click="changeAll()">
                                        {{ $t('BUTTON.GLOBAL.CHANGEALL') }}
                                    </a>
                                </div>
                            </fieldset>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

import europeAddPop from '~va/qnaManager/popup/europeAddPop';
import europeChangePop from '~va/qnaManager/popup/europeChangePop';

export default {
    name: 'europeSharedSvcPop',
    props: {
        rhqCode: '',
        searchSubsidiary: '',
        searchCategoryA: '',
        searchCategoryB: '',
        searchCategoryC: '',
        searchInquiryType1: '',
        searchInquiryType2: '',
        targetUser: '',
        targetUserNm: '',
    },
    data() {
        return {
            pageName: 'europeSharedSvcPop',
        };
    },
    methods: {
        addEu() {
            SDLUtil.show(
                europeAddPop,
                {
                    searchRhqCode: this.rhqCode,
                    searchSubsidiary: this.searchSubsidiary,
                    searchCategoryA: this.searchCategoryA,
                    searchInquiryType1: this.searchInquiryType1,
                    targetUser: this.targetUser,
                    targetUserNm: this.targetUserNm,
                    rtnFunc: () => {
                        this.$emit('close');
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        changeAll() {
            //answererManageList TOP : Search User > UPDATE
            if (SDLUtil.isNull(this.targetUser)) {
                SDLUtil.alert('MESSAGE.DATA.ANSWERER');
                return;
            }

            SDLUtil.show(
                europeChangePop,
                {
                    rhqCode: this.rhqCode,
                    searchSubsidiary: this.searchSubsidiary,
                    searchCategoryA: this.searchCategoryA,
                    searchCategoryB: this.searchCategoryB,
                    searchCategoryC: this.searchCategoryC,
                    searchInquiryType1: this.searchInquiryType1,
                    searchInquiryType2: this.searchInquiryType2,
                    targetUser: this.targetUser,
                    targetUserNm: this.targetUserNm,
                    rtnFunc: () => {
                        this.$emit('close');
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        deleteAll() {
            //answererManageList TOP : Search User > DELETE
            if (SDLUtil.isNull(this.targetUser)) {
                SDLUtil.alert('MESSAGE.DATA.ANSWERER');
                return;
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.DELETE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererModifyEu.skp`,
                            qs.stringify({
                                rhqCode: this.rhqCode,
                                searchSubsidiary: this.searchSubsidiary,
                                searchCategoryA: this.searchCategoryA,
                                searchCategoryB: this.searchCategoryB,
                                searchCategoryC: this.searchCategoryC,
                                searchInquiryType1: this.searchInquiryType1,
                                searchInquiryType2: this.searchInquiryType2,
                                targetUser: this.targetUser,
                                targetUserNm: this.targetUserNm,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            SDLUtil.alert(resp.data.msg);
                            this.$emit('close');
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/europeSharedSvcPop.vue